var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */

        var UiSelectWidget = function () {
            function UiSelectWidget() {
                _classCallCheck(this, UiSelectWidget);
            }

            _createClass(UiSelectWidget, [{
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;

                    document.addEventListener('click', function (event) {
                        var select = event.target.closest('.ui-select');
                        var content = event.target.closest('.ui-select__content');
                        var resetButton = event.target.closest('.ui-select__reset');
                        var toggle = event.target.closest('.ui-select__toggle');
                        var applyButton = event.target.closest('.ui-select__apply-value');

                        if (!select && !content) {
                            _this.closeAllDesktopDropdowns();
                            return;
                        }

                        if (resetButton) {
                            _this.handleResetClick(resetButton);
                            return;
                        }

                        if (toggle) {
                            _this.handleToggleClick(toggle);
                            return;
                        }

                        if (applyButton) {
                            _this.handleApplyClick(applyButton);
                        }
                    }, true);

                    document.addEventListener('change', function (event) {
                        var option = event.target.closest('.ui-select__option-value');

                        if (!option) {
                            return;
                        }

                        var content = option.closest('.ui-select__content');

                        if (!content) {
                            return;
                        }

                        var toggle = _this.getToggleByContentId(content.id);

                        if (!toggle || toggle.dataset.isMultiple === '1') {
                            return;
                        }

                        _this.applySingleValue(toggle, option);

                        if (_this.isMobileToggle(toggle) && window.modal && typeof window.modal.close === 'function') {
                            window.modal.close('.modal2');
                        }
                    }, true);
                }
            }, {
                key: "initState",
                value: function initState() {
                    var _this2 = this;

                    document.querySelectorAll('.ui-select__toggle').forEach(function (toggle) {
                        _this2.syncToggleUi(toggle);
                    });
                }
            }, {
                key: "handleToggleClick",
                value: function handleToggleClick(toggle) {
                    var _this3 = this;

                    var contentId = toggle.dataset ? toggle.dataset.contentId : '';
                    var content = this.getContentById(contentId);
                    var title = this.getSelectTitle(toggle);
                    var select = this.getSelectElement(toggle);
                    var isMobile = this.isMobileToggle(toggle);

                    if (!content) {
                        return;
                    }

                    var isMultiple = toggle.dataset.isMultiple === '1';
                    this.syncContentSelection(content, this.getToggleValue(toggle), isMultiple);

                    if (!isMobile) {
                        if (!select) {
                            return;
                        }

                        if (this.isDesktopDropdownOpened(select)) {
                            this.closeDesktopDropdown(select);
                            return;
                        }

                        this.closeAllDesktopDropdowns(select);
                        this.openDesktopDropdown(select);
                        this.scrollToSelectedOption(content);

                        return;
                    }

                    if (!window.modal || typeof window.modal.open !== 'function') {
                        return;
                    }

                    window.modal.open({
                        content: {
                            htmlDetachSelectorId: contentId
                        },
                        header: {
                            title: title
                        },
                        parentCssClass: ['ui-select-modal', this.getSelectModalCssClass(toggle)].filter(function (className) {
                            return className !== '';
                        }).join(' '),
                        onAfterShow: function onAfterShow(modal) {
                            _this3.scheduleScrollToSelectedOption(content, modal);
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this3.syncContentSelection(content, _this3.getToggleValue(toggle), isMultiple);
                        }
                    });
                }
            }, {
                key: "handleResetClick",
                value: function handleResetClick(button) {
                    var toggle = button.closest('.ui-select__toggle');

                    if (!toggle) {
                        return;
                    }

                    var content = this.getContentById(toggle.dataset.contentId || '');
                    var defaultValue = this.getDefaultValue(toggle);
                    var defaultLabel = this.getDefaultLabel(toggle);
                    var isMultiple = toggle.dataset.isMultiple === '1';

                    if (content) {
                        this.syncContentSelection(content, defaultValue, isMultiple);
                    }

                    this.setToggleState(toggle, defaultValue, defaultLabel);
                }
            }, {
                key: "handleApplyClick",
                value: function handleApplyClick(button) {
                    var content = button.closest('.ui-select__content');

                    if (!content) {
                        return;
                    }

                    var toggle = this.getToggleByContentId(content.id);

                    if (!toggle) {
                        return;
                    }

                    this.applyMultipleValue(toggle, content);

                    if (!this.isMobileToggle(toggle)) {
                        var select = this.getSelectElement(toggle);

                        if (select) {
                            this.closeDesktopDropdown(select, false);
                        }

                        return;
                    }

                    if (window.modal && typeof window.modal.close === 'function') {
                        window.modal.close('.modal2');
                    }
                }
            }, {
                key: "getToggleByContentId",
                value: function getToggleByContentId(contentId) {
                    if (!contentId) {
                        return null;
                    }

                    return document.querySelector('.ui-select__toggle[data-content-id="' + contentId + '"]');
                }
            }, {
                key: "getContentById",
                value: function getContentById(contentId) {
                    if (!contentId) {
                        return null;
                    }

                    return document.getElementById(contentId);
                }
            }, {
                key: "getSelectElement",
                value: function getSelectElement(toggle) {
                    return toggle ? toggle.closest('.ui-select') : null;
                }
            }, {
                key: "isDesktopDropdownOpened",
                value: function isDesktopDropdownOpened(select) {
                    return !!(select && select.classList.contains('ui-select--opened'));
                }
            }, {
                key: "getDefaultLabel",
                value: function getDefaultLabel(toggle) {
                    return toggle && toggle.dataset && toggle.dataset.defaultLabel ? toggle.dataset.defaultLabel : '';
                }
            }, {
                key: "getSelectTitle",
                value: function getSelectTitle(toggle) {
                    var select = this.getSelectElement(toggle);

                    return select && select.dataset && select.dataset.title ? select.dataset.title : '';
                }
            }, {
                key: "getSelectWidgetId",
                value: function getSelectWidgetId(toggle) {
                    var select = this.getSelectElement(toggle);

                    return select && select.dataset && select.dataset.widgetId ? select.dataset.widgetId : '';
                }
            }, {
                key: "getSelectModalCssClass",
                value: function getSelectModalCssClass(toggle) {
                    var select = this.getSelectElement(toggle);

                    return select && select.dataset && select.dataset.modalCssClass ? select.dataset.modalCssClass : '';
                }
            }, {
                key: "getDefaultValue",
                value: function getDefaultValue(toggle) {
                    return toggle && toggle.dataset && toggle.dataset.defaultValue ? toggle.dataset.defaultValue : '';
                }
            }, {
                key: "getToggleValue",
                value: function getToggleValue(toggle) {
                    var toggleValue = toggle.querySelector('.ui-select__toggle-value');

                    return toggleValue ? toggleValue.value : '';
                }
            }, {
                key: "getOptionLabel",
                value: function getOptionLabel(input) {
                    if (input && input.dataset && input.dataset.optionLabel) {
                        return input.dataset.optionLabel;
                    }

                    var option = input.closest('.ui-select__option');

                    if (!option) {
                        return '';
                    }

                    var label = option.querySelector('.ui-select__option-label');

                    return label ? label.textContent.trim() : '';
                }
            }, {
                key: "normalizeValue",
                value: function normalizeValue(value) {
                    if (value === null || typeof value === 'undefined') {
                        return '';
                    }

                    var values = String(value).split(',').map(function (item) {
                        return item.trim();
                    }).filter(function (item) {
                        return item !== '';
                    });

                    return values.sort().join(',');
                }
            }, {
                key: "isChanged",
                value: function isChanged(toggle) {
                    return this.normalizeValue(this.getToggleValue(toggle)) !== this.normalizeValue(this.getDefaultValue(toggle));
                }
            }, {
                key: "syncToggleUi",
                value: function syncToggleUi(toggle) {
                    var toggleLabel = toggle.querySelector('.ui-select__toggle-label');
                    var resetButton = toggle.querySelector('.ui-select__reset');
                    var isChanged = this.isChanged(toggle);

                    if (toggleLabel) {
                        toggleLabel.classList.toggle('changed', isChanged);
                    }

                    if (resetButton) {
                        resetButton.classList.toggle('hidden', !isChanged);
                    }
                }
            }, {
                key: "setToggleValue",
                value: function setToggleValue(toggle, value) {
                    var toggleValue = toggle.querySelector('.ui-select__toggle-value');

                    if (!toggleValue) {
                        return;
                    }

                    toggleValue.value = value;
                    toggleValue.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }, {
                key: "setToggleLabel",
                value: function setToggleLabel(toggle, label) {
                    var toggleLabel = toggle.querySelector('.ui-select__toggle-label');

                    if (toggleLabel) {
                        toggleLabel.textContent = label;
                    }
                }
            }, {
                key: "triggerChangeEvent",
                value: function triggerChangeEvent(toggle, payload) {
                    var select = this.getSelectElement(toggle);

                    if (!select) {
                        return;
                    }

                    select.dispatchEvent(new CustomEvent('ui-select:change', {
                        bubbles: true,
                        detail: Object.assign({}, payload, {
                            contentId: toggle.dataset ? toggle.dataset.contentId || '' : '',
                            defaultLabel: this.getDefaultLabel(toggle),
                            defaultValue: this.getDefaultValue(toggle),
                            inputName: this.getInputName(toggle),
                            isMultiple: toggle.dataset ? toggle.dataset.isMultiple === '1' : false,
                            title: this.getSelectTitle(toggle),
                            widgetId: this.getSelectWidgetId(toggle)
                        })
                    }));
                }
            }, {
                key: "getInputName",
                value: function getInputName(toggle) {
                    var toggleValue = toggle.querySelector('.ui-select__toggle-value');

                    return toggleValue ? toggleValue.name || '' : '';
                }
            }, {
                key: "setToggleState",
                value: function setToggleState(toggle, value, label) {
                    var previousValue = this.getToggleValue(toggle);
                    var previousLabel = this.getToggleLabel(toggle);

                    this.setToggleValue(toggle, value);
                    this.setToggleLabel(toggle, label);
                    this.syncToggleUi(toggle);
                    this.triggerChangeEvent(toggle, {
                        value: value,
                        label: label,
                        previousLabel: previousLabel,
                        previousValue: previousValue
                    });
                }
            }, {
                key: "openDesktopDropdown",
                value: function openDesktopDropdown(select) {
                    var content = select.querySelector('.ui-select__content');

                    if (!content) {
                        return;
                    }

                    select.classList.add('ui-select--opened');
                    content.classList.remove('hidden');
                }
            }, {
                key: "closeDesktopDropdown",
                value: function closeDesktopDropdown(select) {
                    var shouldSyncState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                    var content = select.querySelector('.ui-select__content');
                    var toggle = select.querySelector('.ui-select__toggle');

                    if (!content || !toggle) {
                        return;
                    }

                    if (shouldSyncState) {
                        this.syncContentSelection(content, this.getToggleValue(toggle), toggle.dataset.isMultiple === '1');
                    }

                    select.classList.remove('ui-select--opened');
                    content.classList.add('hidden');
                }
            }, {
                key: "closeAllDesktopDropdowns",
                value: function closeAllDesktopDropdowns() {
                    var _this4 = this;

                    var exceptSelect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    document.querySelectorAll('.ui-select.ui-select--desktop.ui-select--opened').forEach(function (select) {
                        if (exceptSelect && select === exceptSelect) {
                            return;
                        }

                        _this4.closeDesktopDropdown(select);
                    });
                }
            }, {
                key: "getToggleLabel",
                value: function getToggleLabel(toggle) {
                    var toggleLabel = toggle.querySelector('.ui-select__toggle-label');

                    return toggleLabel ? toggleLabel.textContent.trim() : '';
                }
            }, {
                key: "syncContentSelection",
                value: function syncContentSelection(content, value, isMultiple) {
                    var selectedValues = isMultiple ? this.normalizeValue(value).split(',').filter(function (item) {
                        return item !== '';
                    }) : [String(value || '')];

                    content.querySelectorAll('.ui-select__option-value').forEach(function (input) {
                        input.checked = selectedValues.indexOf(input.value) !== -1;
                    });
                }
            }, {
                key: "scheduleScrollToSelectedOption",
                value: function scheduleScrollToSelectedOption(content) {
                    var _this5 = this;

                    var modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var scrollDelay = modal ? 320 : 0;

                    window.setTimeout(function () {
                        _this5.scrollToSelectedOption(content, modal);
                    }, scrollDelay);
                }
            }, {
                key: "scrollToSelectedOption",
                value: function scrollToSelectedOption(content) {
                    var modal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (!content) {
                        return;
                    }

                    window.requestAnimationFrame(function () {
                        var selectedInput = content.querySelector('.ui-select__option-value:checked');

                        if (!selectedInput) {
                            return;
                        }

                        var selectedOption = selectedInput.closest('.ui-select__option');
                        var scrollContainer = content.querySelector('.ui-select__content-wrapper');

                        if (modal && scrollContainer && scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
                            scrollContainer = modal.querySelector('.modal2-content');
                        }

                        if (!selectedOption || !scrollContainer) {
                            return;
                        }

                        var containerRect = scrollContainer.getBoundingClientRect();
                        var optionRect = selectedOption.getBoundingClientRect();
                        var selectedTop = optionRect.top - containerRect.top + scrollContainer.scrollTop;
                        var selectedHeight = selectedOption.offsetHeight;
                        var containerHeight = scrollContainer.clientHeight;
                        var targetScrollTop = Math.max(selectedTop - containerHeight / 2 + selectedHeight / 2, 0);

                        scrollContainer.scrollTop = targetScrollTop;
                    });
                }
            }, {
                key: "applySingleValue",
                value: function applySingleValue(toggle, option) {
                    var label = option.checked ? this.getOptionLabel(option) : this.getDefaultLabel(toggle);
                    var value = option.checked ? option.value : this.getDefaultValue(toggle);

                    this.setToggleState(toggle, value, label);

                    if (!this.isMobileToggle(toggle)) {
                        var select = this.getSelectElement(toggle);

                        if (select) {
                            this.closeDesktopDropdown(select, false);
                        }
                    }
                }
            }, {
                key: "isMobileToggle",
                value: function isMobileToggle(toggle) {
                    var select = this.getSelectElement(toggle);

                    return !!(select && select.classList.contains('ui-select--mobile'));
                }
            }, {
                key: "applyMultipleValue",
                value: function applyMultipleValue(toggle, content) {
                    var _this6 = this;

                    var checkedOptions = Array.from(content.querySelectorAll('.ui-select__option-value:checked'));

                    if (!checkedOptions.length) {
                        this.setToggleState(toggle, this.getDefaultValue(toggle), this.getDefaultLabel(toggle));

                        return;
                    }

                    var values = checkedOptions.map(function (input) {
                        return input.value;
                    });
                    var labels = checkedOptions.map(function (input) {
                        return _this6.getOptionLabel(input);
                    }).filter(function (label) {
                        return label !== '';
                    });

                    var label = this.getDefaultLabel(toggle);

                    if (labels.length === 1) {
                        label = labels[0];
                    } else if (labels.length > 1) {
                        label = labels[0] + ' +' + (labels.length - 1);
                    }

                    this.setToggleState(toggle, values.join(','), label);
                }
            }, {
                key: "isMobile",
                value: function isMobile() {
                    return !!(window.app && window.app.isMobile);
                }
            }]);

            return UiSelectWidget;
        }();

        function initUiSelectWidget() {
            if (window.uiSelectWidget) {
                return;
            }

            window.uiSelectWidget = new UiSelectWidget();
            window.uiSelectWidget.bindEvents();
            window.uiSelectWidget.initState();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', initUiSelectWidget);
        } else {
            initUiSelectWidget();
        }

        window.UiSelectWidget = UiSelectWidget;
    }, {}] }, {}, [1]);